/**
 * Pure step-filtering helpers for the two-tier tour system.
 * All functions take flags/steps as parameters so they're unit-testable.
 */
import { tutorialSteps } from "./tutorialSteps";
import { briefSteps } from "./briefSteps";
import type { TutorialArea, TutorialRole, TutorialStep } from "./types";
import type { FeatureFlags } from "../../config/featureFlags";

export function isStepVisible(
  step: TutorialStep,
  role: TutorialRole,
  flags: FeatureFlags
): boolean {
  if (step.roles && !step.roles.includes(role)) return false;
  if (step.featureFlag && !flags[step.featureFlag]) return false;
  return true;
}

export function getBriefTourSteps(
  role: TutorialRole,
  flags: FeatureFlags,
  steps: TutorialStep[] = [...briefSteps, ...tutorialSteps]
): TutorialStep[] {
  return steps.filter((s) => s.tier === "brief" && isStepVisible(s, role, flags));
}

export function getDetailedTourSteps(
  areas: TutorialArea[],
  role: TutorialRole,
  flags: FeatureFlags,
  steps: TutorialStep[] = tutorialSteps
): TutorialStep[] {
  return steps.filter(
    (s) => s.tier === "detailed" && areas.includes(s.area) && isStepVisible(s, role, flags)
  );
}
